import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DashboardContainer from '../../../sharable/components/DashboardContainer';
import ArticlesHeader from '../ArticlesHeader';
import ArticlesList from '../ArticlesList';
import ArticlesPagination from '../ArticlesPagination';
import ModalManager from '../../../comments-and-posts/modals';
import { Spinner } from '../../../comments-and-posts/dashboard/components';
import { changeArticlesCurrentPage, initializeArticles } from '../../reducers/loadArticlesSlice';
import {
  selectArticlesListIds,
  selectIsArticlesListLoading
} from '../../reducers/articlesSelectors';
import { useFluxibleContext } from '../../../../fluxible-context';

import styles from './ArticlesDashboard.module.scss';
import { useTypedSelector } from 'state';

const ArticlesDashboard = () => {
  const articlesIds = useSelector(selectArticlesListIds);
  const isLoading = useSelector(selectIsArticlesListLoading);
  const pageNum = useTypedSelector(state => state.application.currentRoute?.params?.pageNum);
  const { getStore } = useFluxibleContext();
  const dispatch = useDispatch();

  useEffect(() => {
    if (pageNum) {
      dispatch(changeArticlesCurrentPage(parseInt(pageNum) - 1));
    } else {
      dispatch(initializeArticles());
    }
  }, [dispatch, getStore, pageNum]);

  return (
    <DashboardContainer>
      <ArticlesHeader />
      {isLoading ? (
        <Spinner size="normal" />
      ) : (
        <>
          {articlesIds.length > 0 ? (
            <>
              <ArticlesList />
              <ArticlesPagination />
              <ModalManager />
            </>
          ) : (
            <span className={styles.noArticlesFound}>No articles found.</span>
          )}
        </>
      )}
    </DashboardContainer>
  );
};

export default ArticlesDashboard;
